module.exports = __webpack_public_path__ + "static/media/icon_moxingbaohu.4c5752be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageLargeModelSecurity/icon_moxingbaohu.svg
// module id = 621
// module chunks = 0